<div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
  @for (cosmetic of cosmetics(); track cosmetic.id) {
    <app-public-box-cosmetic-tile
      [imageAlt]="cosmetic.featuredFile.alt"
      [imageSrc]="cosmetic.featuredFile.url"
      [name]="cosmetic.name"
      [brandName]="cosmetic.brand.name"
      [brandSlug]="cosmetic.brand.slug"
      [slug]="cosmetic.slug" />
  }
</div>
